import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  InstallationsCollectionQueryParams,
  EquipmentInstallationsResponse,
  mockEndpointDelay,
} from '@vi-iot/client';

import { MockInstallationsCollection } from './general-management.mocks';

@Injectable()
export class GeneralManagementMockApi {
  getInstallationsCollection(
    params: InstallationsCollectionQueryParams
  ): Observable<EquipmentInstallationsResponse> {
    return of(new MockInstallationsCollection().mock(params)).pipe(delay(mockEndpointDelay));
  }
}
